import Home from '@app/Home';
import Login from '@login/Login';
import { enUS, fr } from 'date-fns/locale';
import { useEffect } from 'react';
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom';
import { PREFERRED_LANG_KEY, saveLang } from './i18n/i18n';
import { useAppStore } from './store';

function Main() {
  const updateLocales = useAppStore(state => state.updateLocales);

  useEffect(() => {
    updateLocales(new Map([['fr-FR', fr], ['en-EN', enUS]]));
  }, []);

  useEffect(() => {
    const userLang = localStorage.getItem(PREFERRED_LANG_KEY) ?? navigator.language;
    saveLang(userLang, false);
  }, []);

  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/*" element={<Home />} />
      </Routes>
    </Router>
  );
}

export default Main;
